export default __webpack_public_path__ + "static/media/about-us-education.c5f01129.jpg";